import { render } from "./TableReports.vue?vue&type=template&id=da399760"
import script from "./TableReports.vue?vue&type=script&lang=js"
export * from "./TableReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__